/**
 * "İÇERİK TAKVİMİNE EKLENDİ Mİ" — SUNUCUDAN.
 *
 * Neden hook: bu durum üç ayrı sayfada gösteriliyordu (brief detayı, analiz listesi,
 * üretim ajanı) ve üçü de yalnız YEREL useState tutuyordu. Sayfa yenilenince sıfırlanıp
 * zaten takvimde olan içerik için buton yeniden "Takvime Ekle" diyordu.
 *
 * Kimlik olarak BAŞLIK değil HEDEF KELİME kullanılır: takvim kartının başlığı
 * sonradan düzenlenebiliyor, kelime sabit kalıyor. Üç sayfa da takvime eklerken
 * hedef kelimeyi keywords[0] olarak yazıyor.
 */
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

type TakvimYaniti = { contentPlans: { keywords?: { keyword: string }[] }[] };

export function useTakvimdeVar(domainId: number | null) {
  const { data } = useQuery({
    queryKey: ["content-plans", domainId],
    enabled: !!domainId,
    queryFn: async (): Promise<TakvimYaniti> => {
      try {
        const r = await fetch(`/api/domains/${domainId}/content-plans`);
        return r.ok ? await r.json() : { contentPlans: [] };
      } catch { return { contentPlans: [] }; }
    },
  });

  const kelimeler = useMemo(() => {
    const s = new Set<string>();
    for (const p of data?.contentPlans ?? []) {
      for (const k of p.keywords ?? []) {
        const kw = (k.keyword ?? "").trim().toLowerCase();
        if (kw) s.add(kw);
      }
    }
    return s;
  }, [data]);

  return (targetKeyword: string) => kelimeler.has((targetKeyword ?? "").trim().toLowerCase());
}
